import * as React from 'react';
import * as styled from './styled';
import {Wrapper} from '../../styled';
import {useFormikContext} from 'formik';
import {TaskObject} from 'api/task/types';
import {Pair} from './components/Pair';
import {PushButton} from '../PushButton';
import {useBlockContext} from '../../../../hooks/useBlockContext';

/**
 * The accordance content.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Accordance(): React.ReactElement {
  const {setFieldValue} = useFormikContext<Partial<TaskObject>>();
  const block = useBlockContext();

  // @ts-ignore
  const pairs = block?.pairs || [] as [string, string][];

  /**
   * Render pairs.
   * @return {JSX.Element}
   */
  function renderPairs(): JSX.Element | undefined {
    /**
     * Render pair.
     * @param {[string, string]} pair
     * @param {number} index
     * @return {JSX.Element}
     */
    function renderPair(
        pair: [string, string],
        index: number,
    ): JSX.Element {
      return (
        <Pair
          key={index}
          pair={pair}
          index={index}
        />
      );
    }

    return pairs.length > 0 ? (
      <styled.Pairs>
        {pairs.map((pair: [string, string], index: number) => (
          renderPair(pair, index)
        ))}
      </styled.Pairs>
    ) : undefined;
  }

  /**
   * Render push button.
   * @return {JSX.Element}
   */
  function renderPushButton(): JSX.Element {
    /**
     * The click event handler.
     * @return {void}
     */
    function handleClick(): void {
      setFieldValue(
        `content.blocks[${block.index}].pairs`,
        [
          ...pairs,
          ['', ''],
        ]
      );
    }

    return (
      <PushButton onClick={handleClick}>
        Добавить пару
      </PushButton>
    );
  }

  return (
    <Wrapper>
      {renderPairs()}
      {renderPushButton()}
    </Wrapper>
  );
}
